import httpservice from "./httpservice";
import fileDownloadService from "./fileDownloadService";

class User {
  async get() {
    return await httpservice.get("/admin/cp/account");
  }
  find(query = {}) {
    const params = {};
    if (query?.page) params.page = query.page;
    if (query?.limit) params.limit = query.limit;
    if (query?.keyword) params.keyword = query.keyword;
    return httpservice.get("/admin/cp/users", {
      params,
    });
  }
  async update(data) {
    const formData = new FormData();
    if (data.firstName) formData.append("firstName", data.firstName);
    if (data.lastName) formData.append("lastName", data.lastName);
    if (data.image) formData.append("avatarUpload", data.image);
    return await httpservice.put("/admin/cp/account", formData);
  }
  async create(data) {
    return await httpservice.post("/admin/cp/users/with-subscription", data);
  }
  async updateUser(data, params = {}) {
    return await httpservice.put("/admin/cp/users/", data, { params });
  }
  async changePassword(data) {
    return await httpservice.put("/admin/cp/account/password-change", data);
  }

  /**
   * GET /admin/cp/users/export
   * Filters: keyword, dateFrom, dateTo (+ headers, format)
   */
  async export(query = {}, callback) {
    const params = {};
    if (query?.keyword) params.keyword = query.keyword;
    if (query?.dateFrom) params.dateFrom = query.dateFrom;
    if (query?.dateTo) params.dateTo = query.dateTo;
    if (query?.headers) params.headers = query.headers;
    if (query?.format) params.format = query.format;

    const today = new Date().toISOString().slice(0, 10);
    return fileDownloadService.download(`/admin/cp/users/export`, `users-export-${today}.csv`, callback, params);
  }
}

export default new User();
